import { useMemo } from 'react';
import { View } from 'react-native';
import { useFormikContext } from 'formik';

import {
  formikNames,
  textCategory,
} from '../../Components/Reservation/constants';
import ResponsiveText from '../../Components/ResponsiveText';
import MenuItemHelper from '../../Helper/MenuItem';
import { ExtraGroup } from '../../RTK/api/types';
import themeStyle from '../../Theme/styles';

import AddOnsCard from './AddOnsCard';
import styles from './styles';

const AddOnContainer = (extraGroup: ExtraGroup) => {
  const { errors } = useFormikContext();
  const isAddOnError = errors[formikNames.ADDONS]?.[extraGroup.name];
  const { isMultiple, isRequired, note } = useMemo(
    () => MenuItemHelper.getExtraGroupSelectionInfo(extraGroup),
    [extraGroup],
  );

  return (
    <View style={themeStyle.pageVerticalSpacingMedium}>
      <View style={themeStyle.spacingBottomSmall}>
        <ResponsiveText category={textCategory.HEADING} style={themeStyle.bold}>
          {extraGroup.name}
          {isRequired && (
            <ResponsiveText
              category={textCategory.HEADING}
              status="danger"
              style={themeStyle.bold}
            >
              {' *'}
            </ResponsiveText>
          )}
        </ResponsiveText>
      </View>
      <ResponsiveText
        category={textCategory.BODY}
        style={themeStyle.spacingBottomMedium}
      >
        {extraGroup.description}
      </ResponsiveText>
      <ResponsiveText
        appearance="hint"
        category={textCategory.BODY}
        status={isAddOnError ? 'danger' : 'basic'}
        style={themeStyle.spacingBottom}
      >
        {note}
      </ResponsiveText>
      <View style={styles.marginBottomOffset}>
        {extraGroup.data.map((extraGroupItem) => (
          <AddOnsCard
            key={extraGroupItem.id}
            isError={isAddOnError}
            isMultiple={isMultiple}
            multipleLimit={extraGroup.maximum_number}
            parentName={extraGroup.name}
            {...extraGroupItem}
          />
        ))}
      </View>
    </View>
  );
};

export default AddOnContainer;
